/**
 * @file 调试控制
 * @author mengchen <mengchen@babytree-inc.com>
 */

import { loadScript } from './index';
import { processEnv } from './config';
import bbtNative from '@bbtfe/native';
import queryString from 'utils/query-string';
import { history } from 'core/history';
import * as Store from 'utils/store';

export function openDebug() {
  // 孕育app内，开发，测试，预上线开启模拟，或者如果页面参数带debug=1则开启模拟（线上查问题留一手）
  if (
    processEnv.hostEnv != 'online' ||
    (processEnv.hostEnv == 'online' &&
      window.location.search.indexOf('debug=1') > -1)
  ) {
    loadScript('//h5cdn.babytreeimg.com/h5_fe_lib/libs/vconsole.min.js').then(
      () => {
        if (window.VConsole) {
          new window.VConsole();
        }
      }
    );
  }
}

let isSimulator = false;

/** 非 App 下从 localStorage（@@babytree-tool-USER-INFO-KEY）注入登录态，与本地开发一致 */
function shouldUseBrowserUserinfoSimulator() {
  return processEnv.hostEnv === 'local' || window.location.href.indexOf("debugUseLocalLoginInfo=1") > -1;
  // return processEnv.hostEnv === 'local';
}

export function openAppSimulator() {
  if (!shouldUseBrowserUserinfoSimulator()) return;
  if (bbtNative.isApp()) {
    return;
  }
  isSimulator = true;
  const ua = navigator.userAgent;
  Object.defineProperty(navigator, 'userAgent', {
    value: `pregnancy ${ua}`, //pregnancy_hm
    writable: false
  });
  // 孕育 app 外：本地 / h5.babytree-test.com 等 test 域走 localStorage 里的 USER-INFO（见下方 Store key）
  // window.USER_INFO = {
  //   "appname": "pregnancy",
  //   "birthday": "2018-12-27",
  //   "certification": "0",
  //   "clientRole": "2",
  //   "currentBabyId": "62960411",
  //   "encUserId": "u142791107054",
  //   "euid": "a6de943210d036bd0d60ee4a7f67a0e0",
  //   "isCheckToBind": "1",
  //   "loginString":
  //    "u142791107054_bb95cda2f85bb376bf193ec6eadca8ad_1732702966",
  //    "nickname": "我是真的喜欢你这样的话丰",
  //    "phoneNum": "188****6377"
  // }
  // 在控制台local-storage中添加 上面window.USER_INFO对象到  @@babytree-tool-USER-INFO-KEY
  window.USER_INFO = Store.get('USER-INFO-KEY') || {}

  bbtNative.ready = function (callback) {
    bbtNative.userinfo = window.USER_INFO;
    callback(bbtNative);
  };
  bbtNative.encryptApi = function (query = {}, callback = () => {}) {
    query.skip = 1;
    callback &&
      callback(
        queryString
          .stringifyUrl({
            url: '',
            query
          })
          .slice(1)
      );
  };
  bbtNative.openWebview = function (title, url) {
    if (url.indexOf(location.origin) > -1) {
      history.push(url.replace(location.origin, ''));
    } else {
      window.location.href = url;
    }
  };
  bbtNative.closeWebview = function () {
    history.goBack();
  };
}

openAppSimulator();
// if (!isSimulator) {
  openDebug();
// }
